import { ApolloClient, InMemoryCache, createHttpLink, split } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';
import { getMainDefinition } from '@apollo/client/utilities';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const GQL_HTTP = BACKEND_URL ? `${BACKEND_URL}/graphql` : '/graphql';
const GQL_WS = BACKEND_URL
  ? BACKEND_URL.replace(/^http/, 'ws') + '/graphql'
  : `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${window.location.host}/graphql`;

const httpLink = createHttpLink({ uri: GQL_HTTP });

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('uav_token');
  return { headers: { ...headers, ...(token ? { authorization: `Bearer ${token}` } : {}) } };
});

const wsLink = new GraphQLWsLink(
  createClient({
    url: GQL_WS,
    connectionParams: () => {
      const token = localStorage.getItem('uav_token');
      return token ? { Authorization: `Bearer ${token}` } : {};
    },
  })
);

const splitLink = split(
  ({ query }) => {
    const def = getMainDefinition(query);
    return def.kind === 'OperationDefinition' && def.operation === 'subscription';
  },
  wsLink,
  authLink.concat(httpLink)
);

export const apolloClient = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache(),
});
